import React from "react";
import { Box, Typography } from "@mui/material";
import { AGENT_INK, AGENT_LINE, AGENT_MUTED } from "../../../agentComponents/agentTheme";

// The row of headline numbers above the fold. One job each: a label, a value,
// and a short qualifier -- no sparklines, because at this size they decorate
// rather than inform.
//
// Laid out with CSS grid rather than MUI Grid on purpose: a MUI Grid container
// with spacing carries negative margins, which collapse against a wrapper and
// drag whatever follows up over this row.

export default function StatTiles({ tiles }) {
  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: { xs: "repeat(2, minmax(0, 1fr))", md: "repeat(4, minmax(0, 1fr))" },
        gap: 2,
      }}
    >
      {tiles.map((t) => (
        <Box
          key={t.label}
          sx={{
            bgcolor: "#fff",
            borderRadius: "12px",
            border: `1px solid ${AGENT_LINE}`,
            px: 2,
            py: 1.75,
            minWidth: 0,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.25, mb: 1.25 }}>
            <Box
              sx={{
                width: 28,
                height: 28,
                borderRadius: "8px",
                bgcolor: t.bg,
                color: t.color,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
                "& svg": { width: 15, height: 15 },
              }}
            >
              {t.icon}
            </Box>
            <Typography sx={{ fontSize: 12, color: AGENT_MUTED, fontWeight: 500 }} noWrap>
              {t.label}
            </Typography>
          </Box>

          <Typography sx={{ fontSize: 20, fontWeight: 700, color: AGENT_INK, lineHeight: 1.2 }} noWrap>
            {t.value}
          </Typography>
          <Typography sx={{ fontSize: 11, color: t.hintColor || "#94A3B8", mt: 0.25 }} noWrap>
            {t.hint}
          </Typography>
        </Box>
      ))}
    </Box>
  );
}
